import colors from 'assets/styles/colors';
import { pxToRem } from 'assets/styles/convertors';
import { mediaQueries } from 'assets/styles/mediaQueries';
import { H3 } from 'components/Text/styles';
import WrappedImage from 'components/WrappedImage';
import UI from 'constants/ui';
import { Breakpoint } from 'hooks/interface/useBreakpoint';
import styled from 'styled-components';

export const PromotionsCardStatus = styled.div<{ $isActive?: boolean }>`
  color: ${({ $isActive }) => ($isActive ? colors.success : colors.error)};
`;

export const PromotionsCardFooter = styled.div`
  display: flex;
  gap: ${pxToRem(5)};
  color: ${colors.gray400};
  font-weight: 400;
  font-size: ${UI.text.lg};
  line-height: ${pxToRem(21)};
`;

export const PromotionsCardDate = styled.div`
  display: flex;
  gap: ${UI.spacing.xs};
  font-size: ${UI.text.md};
  line-height: ${pxToRem(18)};
`;

export const PromotionsCardImage = styled(WrappedImage)`
  border-radius: ${UI.radius.md};
`;

export const PromotionsCardDescription = styled.div`
  color: ${colors.gray200};
  font-weight: 400;
  font-size: ${UI.text.xl};
  line-height: ${pxToRem(24)};
  display: -webkit-box;
  /* Vertical ellipsis after 2 lines
    For browsers that don't support line-clamp, it'll hide the text but no ellipsis
  */
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-height: ${pxToRem(48)};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PromotionsGrid = styled.div`
  position: relative;
  display: grid;
  margin: ${pxToRem(28)} 0;
  column-gap: ${pxToRem(20)};
  row-gap: ${pxToRem(38)};
  grid-template-columns: repeat(1, minmax(0, 1fr));

  ${mediaQueries(Breakpoint.XS)`
    grid-template-columns: repeat(2, minmax(0, 1fr));
  `}

  ${mediaQueries(Breakpoint.LG)`
    grid-template-columns: repeat(3, minmax(0, 1fr));
  `}
`;

export const PromotionCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${UI.spacing.xs};

  @media (hover: hover) {
    &:hover {
      ${H3} {
        text-decoration: underline;
        text-underline-offset: ${pxToRem(5)};
      }
    }
  }
`;
